import React from 'react';
import PropTypes from 'prop-types';
import {PageContainer} from '@/components/organisms';
import LeaderboardSection from '../shared/Leaderboard/LeaderboardSection';

const BackgammonAttributes = ({formData, handleFormChange}) => {
  return (
    <PageContainer data-testid='backgammon-attributes-form'>
      <LeaderboardSection
        formData={formData}
        handleFormChange={handleFormChange}
      />
    </PageContainer>
  );
};

BackgammonAttributes.propTypes = {
  formData: PropTypes.object.isRequired,
  handleFormChange: PropTypes.func.isRequired
};

export default React.memo(BackgammonAttributes);
